<!-- Diseño tipo ChatGPT cuando NO está autenticado -->
<div class="chatgpt-layout" *ngIf="!isAuthenticated">
  <!-- Contenido principal centrado -->
  <div class="chatgpt-main">

    <!-- Área de procesamiento de imágenes -->
    <div class="image-processor-section">
      <!-- Chat Bubble -->
      <div class="chat-bubble">
        <p class="chat-message">
          {{ chatMessage }}<span class="typing-cursor" *ngIf="isTyping">|</span>
        </p>
        <span class="chat-time">{{ getCurrentTime() }}</span>
      </div>

      <!-- Controls -->
      <div class="controls-container">
        <!-- Selector de Plantillas Predefinidas -->
        <div class="control-group template-selector-group">
          <label for="template">Plantilla Predefinida (Opcional)</label>
          <div class="custom-template-select">
            <button 
              class="template-select-button" 
              (click)="toggleTemplateDropdown()"
              [class.expanded]="showTemplateDropdown"
              type="button"
            >
              <span class="template-select-text">{{ getSelectedTemplateName() }}</span>
              <svg class="dropdown-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div class="template-dropdown" [class.expanded]="showTemplateDropdown">
              <div 
                class="template-option"
                [class.selected]="selectedTemplate === null"
                (click)="selectTemplate(null)"
              >
                <div class="template-icon">
                  <!-- Espacio para icono personalizado (se agregará después) -->
                </div>
                <div class="template-info">
                  <div class="template-name">Personalizado</div>
                </div>
              </div>
              <div 
                *ngFor="let template of templates" 
                class="template-option"
                [class.selected]="selectedTemplate === template.id"
                [ngClass]="template.ratioClass || ''"
                (click)="selectTemplate(template.id)"
              >
                <div class="template-icon">
                  <div class="template-icon-preview"></div>
                </div>
                <div class="template-info">
                  <div class="template-name">{{ template.name }}</div>
                  <div class="template-description" *ngIf="template.description">{{ template.description }}</div>
                  <div class="template-dimensions">{{ template.width }} × {{ template.height }} px</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="control-group width-height-group">
          <label for="width">Ancho (px)</label>
          <input 
            type="number" 
            id="width" 
            [(ngModel)]="width" 
            (change)="updatePreview()"
            class="control-input"
            min="1"
            [readonly]="selectedTemplate !== null"
          />
        </div>
        
        <div class="control-group width-height-group">
          <label for="height">Alto (px)</label>
          <input 
            type="number" 
            id="height" 
            [(ngModel)]="height" 
            (change)="updatePreview()"
            class="control-input"
            min="1"
            [readonly]="selectedTemplate !== null"
          />
        </div>
        
        <div class="control-group color-control-group">
          <label for="bgColor">Color de fondo</label>
          <div class="color-picker-container">
            <input 
              type="color" 
              id="bgColor" 
              [value]="backgroundColor === 'transparent' ? '#FFFFFF' : backgroundColor"
              (input)="onColorPickerChange($event); updatePreview()"
              class="color-picker"
              [disabled]="backgroundColor === 'transparent'"
            />
            <input 
              type="text" 
              [(ngModel)]="backgroundColor" 
              (change)="updatePreview()"
              class="color-input"
              placeholder="#FFFFFF o transparent"
            />
            <button 
              type="button"
              class="transparent-button"
              [class.active]="backgroundColor === 'transparent'"
              (click)="backgroundColor = backgroundColor === 'transparent' ? '#FFFFFF' : 'transparent'"
              title="Activar/desactivar fondo transparente"
            >
              <img src="assets/iconotransparente.jpg" alt="icono" width="30" height="30">
            </button>
          </div>
        </div>
        
        <div class="control-group mode-control-group">
          <div class="label-with-tooltip">
            <label for="mode">Modo</label>
            <div class="tooltip-container">
              <svg class="info-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
              </svg>
              <div class="tooltip-content">
                <div class="tooltip-item">
                  <strong>Adaptar:</strong> Mantiene la proporción original de la imagen y la ajusta dentro del tamaño especificado sin recortar. Puede dejar espacios vacíos.
                </div>
                <div class="tooltip-item">
                  <strong>Recortar:</strong> Llena todo el espacio disponible recortando partes de la imagen si es necesario, manteniendo la proporción.
                </div>
                <div class="tooltip-item">
                  <strong>Rellenar:</strong> Estira la imagen para llenar todo el espacio, puede deformar la imagen si las proporciones no coinciden.
                </div>
              </div>
            </div>
          </div>
          <select 
            id="mode" 
            [(ngModel)]="mode" 
            (change)="updatePreview()"
            class="control-select"
            title="Selecciona el modo de redimensionamiento"
          >
            <option value="adaptar" title="Mantiene la proporción, ajusta sin recortar">Adaptar</option>
            <option value="recortar" title="Estira para llenar todo el espacio">Rellenar</option>
            <option value="rellenar" title="Llena el espacio recortando si es necesario">Recortar</option>
          </select>
        </div>
      </div>

      <!-- File Upload Area -->
      <div 
        class="upload-area"
        (dragover)="onDragOver($event)"
        (drop)="onFileDropped($event)"
        [class.has-file]="selectedFile || selectedFiles.length > 0"
      >
        <input 
          type="file" 
          id="fileInput" 
          accept=".zip,.jpg,.jpeg,.png,.webp"
          multiple
          (change)="onFileSelected($event)"
          class="file-input"
        />
        <div class="upload-content">
          <!-- Estado inicial: sin archivo -->
          <div *ngIf="!selectedFile && selectedFiles.length === 0" class="upload-state-initial">
            <svg class="upload-icon" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="17 8 12 3 7 8"></polyline>
              <line x1="12" y1="3" x2="12" y2="15"></line>
            </svg>
            <p class="upload-text-primary">Sube un ZIP o imágenes individuales (JPG, PNG, WebP) (Click para explorar)</p>
            <p class="upload-text-secondary">O arrastra y suelta tus archivos aquí</p>
          </div>
          
          <!-- Estado con archivo cargado -->
          <div *ngIf="selectedFile || selectedFiles.length > 0" class="upload-state-success">
            <!-- Si hay UNA sola imagen, mostrar layout 80/20 -->
            <div *ngIf="selectedFiles.length === 1 && imagePreviewUrls.length === 1" class="single-image-layout">
              <!-- 80% - Mensaje de imagen cargada -->
              <div class="original-image-container">
                <div class="image-info">
                  <p class="success-text-primary">Imagen cargada</p>
                  <p class="success-text-secondary">{{ selectedFiles[0]?.name }}</p>
                </div>
              </div>
              <!-- 20% - Imagen original tal cual -->
              <div class="processed-preview-container">
                <div class="preview-content">
                  <img *ngIf="imagePreviewUrls[0]" [src]="imagePreviewUrls[0]" [alt]="selectedFiles[0]?.name || 'Imagen'" class="processed-preview-image" />
                </div>
              </div>
            </div>
            
            <!-- Si hay múltiples imágenes, mostrar miniaturas -->
            <div *ngIf="selectedFiles.length > 1 && imagePreviewUrls.length > 0" class="image-previews-container">
              <div class="image-previews-grid">
                <div *ngFor="let previewUrl of imagePreviewUrls; let i = index" class="image-preview-item">
                  <img [src]="previewUrl" [alt]="selectedFiles[i]?.name || 'Imagen ' + (i + 1)" class="image-preview-thumbnail" />
                  <div class="image-preview-overlay">
                    <span class="image-preview-name">{{ selectedFiles[i]?.name }}</span>
                  </div>
                </div>
              </div>
              <p class="success-text-primary">{{ selectedFiles.length }} imagen(es) cargada(s) correctamente</p>
            </div>
            
            <!-- Si hay un ZIP, mostrar el icono de carpeta -->
            <div *ngIf="selectedFile" class="zip-file-indicator">
              <div class="success-icon-container">
                <svg class="success-icon-folder" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                </svg>
                <svg class="success-icon-check" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <p class="success-text-primary">Archivo ZIP cargado correctamente</p>
              <p class="success-text-secondary">{{ selectedFile.name }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Process Button -->
      <button 
        class="process-button" 
        (click)="processImages()"
        [disabled]="(!selectedFile && selectedFiles.length === 0) || isProcessing"
      >
        <span *ngIf="!isProcessing">Procesar Imágenes</span>
        <span *ngIf="isProcessing">Procesando... {{ processingProgress }}%</span>
      </button>

      <!-- Progress Bar -->
      <div *ngIf="isProcessing" class="progress-container">
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="processingProgress"></div>
        </div>
      </div>

      <!-- Success Message -->
      <div *ngIf="successMessage" class="message success-message">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
        {{ successMessage }}
      </div>

      <!-- Error Message -->
      <div *ngIf="errorMessage" class="message error-message">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        {{ errorMessage }}
      </div>

      <!-- Info Text -->
      <p class="info-text">
        Soportamos formatos: JPG, PNG, WebP. Puedes subir un ZIP con imágenes o imágenes individuales. El resultado será procesado y descargado automáticamente.
      </p>
    </div>
  </div>
</div>

<!-- Diseño original cuando SÍ está autenticado -->
<main class="main-content" *ngIf="isAuthenticated">
  <!-- Chat Bubble -->
  <div class="chat-bubble">
    <p class="chat-message">
      {{ chatMessage }}<span class="typing-cursor" *ngIf="isTyping">|</span>
    </p>
    <span class="chat-time">{{ getCurrentTime() }}</span>
  </div>

  <!-- Controls -->
  <div class="controls-container">
    <!-- Selector de Plantillas Predefinidas -->
    <div class="control-group template-selector-group">
      <label for="template">Plantilla Predefinida (Opcional)</label>
      <div class="custom-template-select">
        <button 
          class="template-select-button" 
          (click)="toggleTemplateDropdown()"
          [class.expanded]="showTemplateDropdown"
          type="button"
        >
          <span class="template-select-text">{{ getSelectedTemplateName() }}</span>
          <svg class="dropdown-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="template-dropdown" [class.expanded]="showTemplateDropdown">
          <div 
            class="template-option"
            [class.selected]="selectedTemplate === null"
            (click)="selectTemplate(null)"
          >
            <div class="template-icon">
              <!-- Espacio para icono personalizado (se agregará después) -->
            </div>
            <div class="template-info">
              <div class="template-name">Personalizado</div>
            </div>
          </div>
          <div 
            *ngFor="let template of templates" 
            class="template-option"
            [class.selected]="selectedTemplate === template.id"
            [ngClass]="template.ratioClass || ''"
            (click)="selectTemplate(template.id)"
          >
            <div class="template-icon">
              <div class="template-icon-preview"></div>
            </div>
            <div class="template-info">
              <div class="template-name">{{ template.name }}</div>
              <div class="template-description" *ngIf="template.description">{{ template.description }}</div>
              <div class="template-dimensions">{{ template.width }} × {{ template.height }} px</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="control-group width-height-group">
      <label for="width">Ancho (px)</label>
        <input 
          type="number" 
          id="width" 
          [(ngModel)]="width" 
          (change)="updatePreview()"
          class="control-input"
          min="1"
          [readonly]="selectedTemplate !== null"
        />
    </div>
    
    <div class="control-group width-height-group">
      <label for="height">Alto (px)</label>
        <input 
          type="number" 
          id="height" 
          [(ngModel)]="height" 
          (change)="updatePreview()"
          class="control-input"
          min="1"
          [readonly]="selectedTemplate !== null"
        />
    </div>
    
    <div class="control-group color-control-group">
      <label for="bgColor">Color de fondo</label>
      <div class="color-picker-container">
        <input 
          type="color" 
          id="bgColor" 
          [value]="backgroundColor === 'transparent' ? '#FFFFFF' : backgroundColor"
          (input)="onColorPickerChange($event); updatePreview()"
          class="color-picker"
          [disabled]="backgroundColor === 'transparent'"
        />
        <input 
          type="text" 
          [(ngModel)]="backgroundColor" 
          (change)="updatePreview()"
          class="color-input"
          placeholder="#FFFFFF o transparent"
        />
        <button 
          type="button"
          class="transparent-button"
          [class.active]="backgroundColor === 'transparent'"
          (click)="backgroundColor = backgroundColor === 'transparent' ? '#FFFFFF' : 'transparent'"
          title="Activar/desactivar fondo transparente"
        >
          <img src="assets/iconotransparente.jpg" alt="icono" width="30" height="30">
        </button>
      </div>
    </div>
    
    <div class="control-group mode-control-group">
      <div class="label-with-tooltip">
        <label for="mode">Modo</label>
        <div class="tooltip-container">
          <svg class="info-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
          <div class="tooltip-content">
            <div class="tooltip-item">
              <strong>Adaptar:</strong> Mantiene la proporción original de la imagen y la ajusta dentro del tamaño especificado sin recortar. Puede dejar espacios vacíos.
            </div>
            <div class="tooltip-item">
              <strong>Recortar:</strong> Llena todo el espacio disponible recortando partes de la imagen si es necesario, manteniendo la proporción.
            </div>
            <div class="tooltip-item">
              <strong>Rellenar:</strong> Estira la imagen para llenar todo el espacio, puede deformar la imagen si las proporciones no coinciden.
            </div>
          </div>
        </div>
      </div>
      <select 
        id="mode" 
        [(ngModel)]="mode" 
        (change)="updatePreview()"
        class="control-select"
        title="Selecciona el modo de redimensionamiento"
      >
        <option value="adaptar" title="Mantiene la proporción, ajusta sin recortar">Adaptar</option>
        <option value="recortar" title="Estira para llenar todo el espacio">Rellenar</option>
        <option value="rellenar" title="Llena el espacio recortando si es necesario">Recortar</option>
      </select>
    </div>
  </div>

  <!-- File Upload Area -->
  <div 
    class="upload-area"
    (dragover)="onDragOver($event)"
    (drop)="onFileDropped($event)"
    [class.has-file]="selectedFile || selectedFiles.length > 0"
  >
    <input 
      type="file" 
      id="fileInput" 
      accept=".zip,.jpg,.jpeg,.png,.webp"
      multiple
      (change)="onFileSelected($event)"
      class="file-input"
    />
    <div class="upload-content">
      <!-- Estado inicial: sin archivo -->
      <div *ngIf="!selectedFile && selectedFiles.length === 0" class="upload-state-initial">
        <svg class="upload-icon" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="17 8 12 3 7 8"></polyline>
          <line x1="12" y1="3" x2="12" y2="15"></line>
        </svg>
        <p class="upload-text-primary">Sube un ZIP o imágenes individuales (JPG, PNG, WebP) (Click para explorar)</p>
        <p class="upload-text-secondary">O arrastra y suelta tus archivos aquí</p>
      </div>
      
      <!-- Estado con archivo cargado -->
      <div *ngIf="selectedFile || selectedFiles.length > 0" class="upload-state-success">
        <!-- Si hay UNA sola imagen, mostrar layout 80/20 -->
        <div *ngIf="selectedFiles.length === 1 && imagePreviewUrls.length === 1" class="single-image-layout">
          <!-- 80% - Mensaje de imagen cargada -->
          <div class="original-image-container">
            <div class="image-info">
              <p class="success-text-primary">Imagen cargada</p>
              <p class="success-text-secondary">{{ selectedFiles[0]?.name }}</p>
            </div>
          </div>
          <!-- 20% - Imagen original tal cual -->
          <div class="processed-preview-container">
            <div class="preview-content">
              <img *ngIf="imagePreviewUrls[0]" [src]="imagePreviewUrls[0]" [alt]="selectedFiles[0]?.name || 'Imagen'" class="processed-preview-image" />
            </div>
          </div>
        </div>
        
        <!-- Si hay múltiples imágenes, mostrar miniaturas -->
        <div *ngIf="selectedFiles.length > 1 && imagePreviewUrls.length > 0" class="image-previews-container">
          <div class="image-previews-grid">
            <div *ngFor="let previewUrl of imagePreviewUrls; let i = index" class="image-preview-item">
              <img [src]="previewUrl" [alt]="selectedFiles[i]?.name || 'Imagen ' + (i + 1)" class="image-preview-thumbnail" />
              <div class="image-preview-overlay">
                <span class="image-preview-name">{{ selectedFiles[i]?.name }}</span>
              </div>
            </div>
          </div>
          <p class="success-text-primary">{{ selectedFiles.length }} imagen(es) cargada(s) correctamente</p>
        </div>
        
        <!-- Si hay un ZIP, mostrar el icono de carpeta -->
        <div *ngIf="selectedFile" class="zip-file-indicator">
          <div class="success-icon-container">
            <svg class="success-icon-folder" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
            </svg>
            <svg class="success-icon-check" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
          <p class="success-text-primary">Archivo ZIP cargado correctamente</p>
          <p class="success-text-secondary">{{ selectedFile.name }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Process Button -->
  <button 
    class="process-button" 
    (click)="processImages()"
    [disabled]="(!selectedFile && selectedFiles.length === 0) || isProcessing"
  >
    <span *ngIf="!isProcessing">Procesar Imágenes</span>
    <span *ngIf="isProcessing">Procesando... {{ processingProgress }}%</span>
  </button>

  <!-- Progress Bar -->
  <div *ngIf="isProcessing" class="progress-container">
    <div class="progress-bar">
      <div class="progress-fill" [style.width.%]="processingProgress"></div>
    </div>
  </div>

  <!-- Success Message -->
  <div *ngIf="successMessage" class="message success-message">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
      <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
    {{ successMessage }}
  </div>

  <!-- Error Message -->
  <div *ngIf="errorMessage" class="message error-message">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
    {{ errorMessage }}
  </div>

  <!-- Info Text -->
      <p class="info-text">
        Soportamos formatos: JPG, PNG, WebP. Puedes subir un ZIP con imágenes o imágenes individuales. El resultado será procesado y descargado automáticamente.
      </p>
</main>
<footer>
  <div class="footer-container">
    <p data-i18n="footerCopyright">&copy; 2025 Punto de Fuga. Todos los derechos reservados.</p>
    <div class="footer-links">
      <a routerLink="/privacy" data-i18n="footerPrivacy">Política de Privacidad</a>
      <a routerLink="/support" data-i18n="footerContact">Soporte</a>
    </div>
  </div>
</footer>
